import { Google } from "@mui/icons-material";
import { Button } from "@mui/material";

const OAuth2Component = () => {

    return (
        <div className='w-80 flex flex-col items-center'>
      {/*     <br/>
      <div className="my-4 flex"> <hr className='w-full border-t-2 border-gray-300'/> <div className='ml-2 mr-2'>OR</div> <hr className='w-full border-t-2 border-gray-300'/></div>
      <Button variant="outlined" fullWidth startIcon={
        <Google fontSize='10' className="text-red-600 w-6 h-6" />}>
        <div className=''> Continue with Google </div> 
      </Button>*/}
      </div>
    )
}

export default OAuth2Component;